
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Quotes`}</h1>
<p>{`Always use double quotes `}<inlineCode parentName="p">{`"`}</inlineCode>{` for string props.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
<Component fooBar='value' />

// Good
<Component fooBar="value" />
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;